import { createContext } from 'react';

const OverlayContext = createContext({
	bgColor: '#1caddd',
	setBgColor: (bgColor: string) => {}
});

export default OverlayContext;
